<template>
  <div>
    <vs-button @click="topluIslem()" style="height: 40px; border-radius: 3px" color="success" type="gradient">Toplu
      İşlem</vs-button>
    <vs-popup title="Toplu İşlem" :active.sync="popupTopluIslem">
      <div>
        <b-row>
          <b-col>
            <v-select v-model="selected2" placeholder="Pazaryeri Seçiniz" label="name" @input="pazaryeriList"
              :options="pazaryerleri" />
          </b-col>

        </b-row>

        <vs-divider />
        <b-row>
          <b-col><vs-input class="inputx" :ref="oran" v-model="oran" /></b-col>
          <b-col> <vs-button @click="topluIslemGonder()" style="height: 40px; border-radius: 3px" color="primary"
              icon="done" type="gradient">Oran Güncelle</vs-button></b-col>

        </b-row>

        <vs-divider />
        <b-row>
          <b-col>
            <b-row align-h="start">
              <b-col cols="12" md="auto">
                <p>Pasif</p>
              </b-col>
              <b-col cols="12" md="auto">
                <vs-switch v-model="islemDurumu" style="border-radius: 25px" />
              </b-col>
              <b-col cols="12" md="auto">
                <p>Aktif</p>
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <vs-button @click="topluIslemDurumGonder()" style="height: 40px; border-radius: 3px" color="primary"
              icon="done" type="gradient">Durum Güncelle</vs-button>
          </b-col>
        </b-row>

        <vs-divider />
        <b-col lg="3" sm="12" style="margin-bottom: 5px">
          <vs-button @click="activePrompt = true" size="small" icon="delete" type="gradient"
            color="danger">Sil</vs-button>
        </b-col>
        <vs-table :data="topluislemlist">
          <template slot="thead">
            <vs-th> </vs-th>
            <vs-th sort-key="stokkodu">Stok Kodu</vs-th>
            <vs-th sort-key="Barkod">Barkod</vs-th>
            <vs-th sort-key="StokAdi">Stok Adı</vs-th>
            <vs-th sort-key="renk">Renk</vs-th>
            <vs-th sort-key="SonAlis">Son Alış</vs-th>
            <vs-th sort-key="LISTE_FIAT">Piyasa Fiyatı</vs-th>
            <vs-th sort-key="stokAdet">Stok Adet</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <img :style="{ height: '50px', weight: '50px' }" :src="data[indextr].resimLink" />
              </vs-td>
              <vs-td :data="data[indextr].stokKodu">
                {{ data[indextr].stokKodu }}<br />
              </vs-td>
              <vs-td :data="data[indextr].Barkod">
                {{ data[indextr].Barkod }}
              </vs-td>
              <vs-td :data="data[indextr].StokAdi">
                {{ data[indextr].StokAdi }}
              </vs-td>
              <vs-td :data="data[indextr].renk">
                {{ data[indextr].renk }}
              </vs-td>
              <vs-td :data="data[indextr].SonAlis">
                {{ data[indextr].SonAlis }}
              </vs-td>
              <vs-td :data="data[indextr].LISTE_FIAT">
                {{ data[indextr].LISTE_FIAT }}
              </vs-td>
              <vs-td :data="data[indextr].stokAdet">
                {{ data[indextr].stokAdet }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <vs-prompt title="Seçilen kayıtlar silinecek emin misiniz?" acceptText="Sil" cancelText="Vazgeç" color="danger"
        @accept="kartSil" :active.sync="activePrompt">
      </vs-prompt>
    </vs-popup>
  </div>
</template>
<script>
import state from "../../../../store/state";
import Store from "../../../../store/store";
import vSelect from "vue-select";
export default {
  components: {
    vSelect,
  },
  props: ["secilenStok"],
  data() {
    return {
      activePrompt: false,
      islemDurumu: false,
      oran: 0,
      topluislemlist: [],
      popupTopluIslem: false,
      selected2: [],
      pazaryerleri: [],
    };
  },
  methods: {
    kartSil() {
      console.log("inn")
      var vm = this;
      var vs = this.$vs;
      let stokKodlari = [], barkodlar = [];
      if (vm.selected2.length == 0) {
        vs.notify({
          text: "Pazaryeri seçimi yapmadınız.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        console.log(vm.secilenStok)
        vm.secilenStok.forEach((val, ind) => {
          if (ind == vm.secilenStok.length - 1) {
            barkodlar += val.Barkod.trim()
            stokKodlari += val.stokKodu.trim()
          } else {
            barkodlar += val.Barkod.trim() + ","
            stokKodlari += val.stokKodu.trim() + ","
          }
        });

        const soap = require("soap");
        const url = state.sistemAddress;

        const args = {
          token: Store.state.tokenId,
          pazaryerleri: vm.selected2.name,
          stokKodlari: stokKodlari,
          barkodlar: barkodlar
        };

        console.log(args);
        soap.createClient(url, function (err, client) {
          client.eslesenStokSil(args, function (err, result) {
            if (result.eslesenStokSilResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            vm.veriler = JSON.parse(result.eslesenStokSilResult);            
            if(vm.veriler.response == "Ok"){
              vs.notify({
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            }else{
              vs.notify({
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center",
              });
            }
          });
        });
      }

    },
    topluIslemDurumGonder() {
      var islemDurum = 0;
      if (this.islemDurumu === true) {
        islemDurum = 1;
      } else {
        islemDurum = 0;
      }

      var stoklist = Store.state.uzum.secilenStokListTopluIslem;
      var barcodlar = [];
      var barcodetoString = "";

      //   var vm = this;
      stoklist.forEach((val, index) => {
        barcodlar.push(stoklist[index].Barkod);
      });
      barcodetoString = barcodlar.join();
      //   var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        idler: barcodetoString,
        pazaryeri: this.selected2.title,
        durum: islemDurum,
      };

      var vs = this.$vs;
      if (this.selected2.title == undefined || barcodlar == []) {
        vs.notify({
          text: "Tüm alanları doldurunuz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-center",
        });
      } else {
        //  console.log(args);

        soap.createClient(url, function (err, client) {
          client.satisDurumlari(args, function (err, result) {
            if (result.satisDurumlariResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            var vm = this;
            vm.veriler = JSON.parse(result.satisDurumlariResult);
            //  console.log(vm.veriler)
            if (vm.veriler.response == "Ok") {
              vs.notify({
                title: "Güncelleme",
                text: "Seçilenler orana göre güncellendi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            }
          });
        });
      }
    },
    topluIslemGonder() {
      var stoklist = Store.state.uzum.secilenStokListTopluIslem;
      var barcodlar = [];
      var barcodetoString = "";

      //   var vm = this;
      stoklist.forEach((val, index) => {
        barcodlar.push(stoklist[index].Barkod);
      });

      // console.log(barcodlar.join());
      barcodetoString = barcodlar.join();

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        idler: barcodetoString,
        pazaryeri: this.selected2.title,
        oran: this.oran,
      };

      var vs = this.$vs;
      if (
        this.selected2.title == undefined ||
        this.oran == undefined ||
        barcodlar == []
      ) {
        vs.notify({
          text: "Tüm alanları doldurunuz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "top-center",
        });
      } else {
        //  console.log(args);

        soap.createClient(url, function (err, client) {
          client.pazaryeriSecilenleriGuncelle(args, function (err, result) {
            if (result.pazaryeriSecilenleriGuncelleResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            var vm = this;
            vm.veriler = JSON.parse(result.pazaryeriSecilenleriGuncelleResult);
            //  console.log(vm.veriler)
            if (vm.veriler.response == "Ok") {
              vs.notify({
                title: "Güncelleme",
                text: "Seçilenler orana göre güncellendi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            }
          });
        });
      }
    },
    pazaryeriList(text) {
      // console.log(text);
    },
    topluIslem() {
      this.popupTopluIslem = true;
      // console.log(Store.state.uzum.secilenStokListTopluIslem);
      // this.topluislemlist = Store.state.uzum.secilenStokListTopluIslem;
      this.topluislemlist = this.secilenStok;
    },
  },
  created() {
    this.pazaryerleri = Store.state.uzum.menuListForTabs;

  }
};
</script>